import ExportAdaptiveQuizAttemptReportData from './ExportAdaptiveQuizAttemptReportData';

export default ExportAdaptiveQuizAttemptReportData;
